module.exports = __webpack_public_path__ + "media/images/placeholder-dog-199cf5e42429b487171067d4cae1377e.jpg";